import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useApi } from './client'

export type TelegramStatusUnlinked = { linked: false }
export type TelegramStatusLinked = { linked: true; chatIdMasked: string }
export type TelegramStatus = TelegramStatusUnlinked | TelegramStatusLinked

export type TelegramLinkCode = {
  code: string
  expiresAt: string
  botUsername: string
}

const ROOT = '/settings/telegram'
const KEY = ['settings', 'telegram'] as const

export function useTelegramStatus() {
  const api = useApi()
  return useQuery({
    queryKey: KEY,
    queryFn: () => api<TelegramStatus>(ROOT),
  })
}

export function useCreateLinkCode() {
  const api = useApi()
  const qc = useQueryClient()
  return useMutation({
    mutationFn: () => api<TelegramLinkCode>(`${ROOT}/link-code`, { method: 'POST' }),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  })
}

export function useUnlinkTelegram() {
  const api = useApi()
  const qc = useQueryClient()
  return useMutation({
    mutationFn: () => api<{ unlinked: true }>(ROOT, { method: 'DELETE' }),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  })
}
